//@ts-nocheck
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { postApiData } from "../helpers/AxiosInstance";

const usePostHook = ({ queryKey, navigateURL }) => {
  // Getting cached data from queryClient
  const queryClient = useQueryClient();
  const navigate = useNavigate();

  const {
    isPending: isPostLoading,
    error: isPostError,
    data: postData,
    mutateAsync,
    isSuccess: isPostSuccess,
  } = useMutation({
    mutationFn: postApiData,
    onSuccess: async (data) => {
      if (
        data?.status === 201 ||
        data?.status === 200 ||
        data?.status === 202
      ) {
        toast.success(data?.data?.message ?? "Success");
        if (navigateURL) {
          navigate(navigateURL);
        }
      }
    },
    onError: (error) => {
      console.error("Error");
    },
    onSettled: async () => {
      queryClient.invalidateQueries(queryKey);
    },
  });

  return {
    isPostLoading,
    isPostError,
    postData,
    isPostSuccess,
    mutateAsync,
  };
};

export default usePostHook;
